export interface RouteMetadata {
  title: string;
  parent?: string | null;
}

export const buildBreadcrumb = (
  pathname: string,
  routeMeta: Record<string, RouteMetadata>,
) => {
  const items: Array<{ path: string; title: string }> = [];
  let current: string | null | undefined = pathname;

  while (current) {
    const route: RouteMetadata | undefined = routeMeta[current];
    if (!route) break;
    items.unshift({ path: current, title: route.title });
    current = route.parent;
  }
  return items;
};
